export default __webpack_public_path__ + "static/media/p13.ff8caef1.jpg";